import { render, staticRenderFns } from "./UnidadMedidaList.vue?vue&type=template&id=64bf2ffa&scoped=true&"
import script from "./UnidadMedidaList.vue?vue&type=script&lang=js&"
export * from "./UnidadMedidaList.vue?vue&type=script&lang=js&"
import style0 from "./UnidadMedidaList.vue?vue&type=style&index=0&id=64bf2ffa&lang=scss&scoped=true&"
import style1 from "./UnidadMedidaList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./UnidadMedidaList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bf2ffa",
  null
  
)

export default component.exports